<script setup lang="ts">
import { MoreHorizontal, Star, Pencil, Trash2 } from 'lucide-vue-next'
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger,
} from '~/components/ui/dropdown-menu'
import type { ConversationSummary } from '~/stores/chats'

const props = defineProps<{ conv: ConversationSummary }>()
const emit = defineEmits<{
  rename: []
  delete: []
}>()

const { t } = useI18n()
const chats = useChatsStore()
</script>

<template>
  <DropdownMenu>
    <DropdownMenuTrigger as-child>
      <button
        type="button"
        class="h-5 w-5 flex items-center justify-center rounded-md opacity-0 group-hover:opacity-100 hover:bg-accent-lighter transition-all shrink-0"
      >
        <MoreHorizontal class="h-3 w-3" />
      </button>
    </DropdownMenuTrigger>
    <DropdownMenuContent class="min-w-[160px]" side="right" align="start">
      <DropdownMenuItem class="px-2" @select="chats.toggleFavorite(conv)">
        <Star class="h-4 w-4" :class="conv.is_favorite ? 'fill-warning-ink text-warning-ink' : ''" />
        {{ conv.is_favorite ? t('history.removeFavorite') : t('history.addFavorite') }}
      </DropdownMenuItem>
      <DropdownMenuItem class="px-2" @select="emit('rename')">
        <Pencil class="h-4 w-4" />
        {{ t('sidebar.rename') }}
      </DropdownMenuItem>
      <DropdownMenuSeparator />
      <!-- A plain button rather than a `DropdownMenuItem`: a menu item closes the menu on select,
           which would unmount the confirmation before it could be answered (MAR-474). -->
      <InlineConfirm :question="t('history.deleteConfirm')" @confirm="emit('delete')">
        <template #default="{ arm }">
          <button
            type="button"
            class="flex w-full items-center gap-2 px-2 py-1.5 text-sm rounded-md cursor-pointer outline-none hover:bg-destructive/10 focus:bg-destructive/10 text-destructive transition-colors"
            @click="arm"
          >
            <Trash2 class="h-4 w-4" />
            {{ t('common.delete') }}
          </button>
        </template>
      </InlineConfirm>
    </DropdownMenuContent>
  </DropdownMenu>
</template>
